import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { CTASection } from "@/components/CTASection";
import { CITIES } from "@/lib/site";
import { buildBreadcrumbs } from "@/components/SchemaJsonLd";
import commercialImg from "@/assets/commercial-floor.jpg";
import { MapPin } from "lucide-react";

export const Route = createFileRoute("/service-areas")({
  head: () => ({
    meta: [
      { title: "Calgary Service Areas | MLC Epoxy Floors" },
      { name: "description", content: "MLC Epoxy Floors serves Calgary and surrounding areas — Airdrie, Chestermere, Cochrane, Okotoks, and nearby communities." },
      { property: "og:title", content: "Calgary Service Areas | MLC Epoxy Floors" },
      { property: "og:description", content: "Premium epoxy floor coatings throughout Calgary and surrounding Alberta communities." },
      { property: "og:url", content: "/service-areas" },
    ],
    links: [{ rel: "canonical", href: "/service-areas" }],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([{ name: "Home", href: "/" }, { name: "Service Areas", href: "/service-areas" }])) }],
  }),
  component: AreasHub,
});

function AreasHub() {
  return (
    <>
      <PageHero eyebrow="Coverage" title="Proudly Serving Calgary & Surrounding Areas" body="Headquartered in Airdrie, Alberta. Installing premium epoxy and polyaspartic floor coatings throughout Calgary, Airdrie, Chestermere, Cochrane, Okotoks, and nearby communities." image={commercialImg} />
      <section className="container-x py-20">
        <div className="mb-12">
          <SectionHeading title="Calgary & Surrounding Areas" />
          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {CITIES.map((c) => (
              <Link key={c.slug} to={`/service-areas/${c.slug}` as string} className="group rounded-sm border border-border bg-charcoal p-6 hover:border-copper transition-colors">
                <div className="flex items-center gap-2"><MapPin className="h-4 w-4 text-copper" /><span className="text-xs uppercase tracking-widest text-muted-foreground">{c.region}</span></div>
                <p className="mt-3 text-xl text-silver-light group-hover:text-copper">{c.name}, {c.state}</p>
                <p className="mt-2 text-sm text-silver">Premium epoxy & polyaspartic floor coatings in {c.name}.</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
